import React, { useState, useRef, useEffect } from "react";
import dayjs from "dayjs";
import LeftIcon from "../assets/images/greyIcons/filled.png";
import RightIcon from "../assets/images/greyIcons/Icon.png";
import ArrowDown from "../assets/icons/down-filled.png";
import "dayjs/locale/zh-cn";
import CustomTitle from "./CustomTitle";
import CustomInput from "./CustomInput";
import CustomParagraph from "./CustomParagraph";
import { Calendar, Col, Row, Select, Button } from "antd";
import CustomSelect from "./CustomSelect";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { ReportingPeriodList } from "../common/static_data";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isSameOrAfter);

const HomeDateFilter = ({ keys,handleDataFromChild, initialDateModal }) => {
  const [rangeStart, setRangeStart] = useState(initialDateModal?.start_date);
  // const [disableCalendar, setDisableCalendar] = useState(true);
  // const [disableCalendar, setDisableDate] = useState(true);
  const [period, setPeriod] = useState(initialDateModal?.period);
  const [rangeEnd, setRangeEnd] = useState(initialDateModal?.end_date);
  const [dateError, setDateError] = useState("");
  const [error, setError] = useState(false);
  const buttonPress = useRef(false);
  const [calendarValue, setCalendarValue] = useState(dayjs());

  // Reset calendar when period changes
  useEffect(() => {
    setCalendarValue(dayjs());
  }, [keys]);

  // Get last 3 full months dynamically
  const now = new Date();
  const dynamicMonths = Array.from({ length: 3 }).map((_, i) => {
    const date = new Date(now.getFullYear(), now.getMonth() - (i + 1), 1); // Previous full months
    const label = date.toLocaleString("default", {
      month: "long",
      year: "numeric",
    });
    return { label, value: label };
  });

  const dynamicLastmonths = [...ReportingPeriodList, ...dynamicMonths];

  
  const onDateChange = (val) => {
    if (buttonPress.current === false) {
      let start = rangeStart;
      let end = rangeEnd;
      setError(false);
      if (!rangeStart) {
        start = val.format("MM/DD/YYYY");
        setRangeStart(val.format("MM/DD/YYYY"));
      } else if (!rangeEnd) {
        if (dayjs(val).isSameOrAfter(dayjs(rangeStart), "day")) {
          end = val.format("MM/DD/YYYY");
          setRangeEnd(val.format("MM/DD/YYYY"));
        } else {
          setError(true);
        }
      } else {
        setRangeEnd(null);
        end = null;
        start = val.format("MM/DD/YYYY");
        setRangeStart(val.format("MM/DD/YYYY"));
      }
      // sendDataToParent(start, end, period);
      setPeriod("Custom");
      sendDataToParent(start, end, "Custom");
      // if (end) {
        //   setCalendarValue(dayjs(end));
        
      // }
    }
    buttonPress.current = false;
  };
  
  const handlePeriodChange = (data) => {
    let today = dayjs();
    setPeriod(data);
    setCalendarValue(today);  
    let endDate = dayjs().format("MM/DD/YYYY");
    let startDate = null;
    if (data === "Last 7 days") {
      startDate = today.subtract("6", "day").format("MM/DD/YYYY");
    } else if (data === "Last 30 days") {
      startDate = today.subtract("29", "day").format("MM/DD/YYYY");
    } else if (data === "Month to date") {
      startDate = today.startOf("month").format("MM/DD/YYYY");
    } else if (data === "Quarter to date") {
      const month = today.month();
      const quarterStartMonth = Math.floor(month / 3) * 3;
      startDate = today
        .month(quarterStartMonth)
        .startOf("month")
        .format("MM/DD/YYYY");
    } else if (data === "Year to date") {
      const startOfYear = dayjs().startOf("year");
      startDate = startOfYear.format("MM/DD/YYYY");
    }
    // static  monts
    // else if (data === "December 2024") {
    //   startDate = dayjs("2024-12-01").startOf("day").format("MM/DD/YYYY");
    //   endDate = dayjs("2024-12-01").endOf("month").format("MM/DD/YYYY");
    // } else if (data === "November 2024") {
    //   startDate = dayjs("2024-11-01").startOf("day").format("MM/DD/YYYY");
    //   endDate = dayjs("2024-11-01").endOf("month").format("MM/DD/YYYY");
    // } else if (data === "October 2024") {
    //   startDate = dayjs("2024-10-01").startOf("day").format("MM/DD/YYYY");
    //   endDate = dayjs("2024-10-01").endOf("month").format("MM/DD/YYYY");
    // }
    // static  monts  end
    else if (data === "Custom" || data === "All time") {
      const disable = data === "All time";
      // setDisableCalendar(disable);
      startDate = null;
      endDate = null;
    } else {
      const parsed = dayjs(data);
      if (parsed.isValid()) {
        startDate = parsed.startOf("month").format("MM/DD/YYYY");
        endDate = parsed.endOf("month").format("MM/DD/YYYY");
      } else {
        startDate = null;
        endDate = null;
      }
    }
    setRangeStart(startDate);
    setRangeEnd(endDate);
    sendDataToParent(startDate, endDate, data);
  };

  const sendDataToParent = (start, end, period) => {
    let rangeModel = {
      start_date: start,
      end_date: end,
      period: period,
    };
   // if (period === "Custom") {    //for the time bieng this check is commented

      // Only call when end_date exists
      // if (rangeModel?.end_date) {
      //   handleDataFromChild(rangeModel);
      // }
   // } else {
      // Call for non-custom periods
      handleDataFromChild(rangeModel);
   // }
  };

  const handleDateSelect = (e, type) => {
    const input = e.target.value;
  
    // Update input field value immediately
    if (type === "start") {
      setRangeStart(input);
    } else {
      setRangeEnd(input);
    }
  
    const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  
    // Validate input format and logical date
    if (dateRegex.test(input) && dayjs(input, "MM/DD/YYYY", true).isValid()) {
      setDateError(""); // Clear error
  
      const formatted = dayjs(input, "MM/DD/YYYY").format("MM/DD/YYYY"); // Keep it in desired format
      
      if (type === "start") {
        const endValid = dayjs(rangeEnd, "MM/DD/YYYY", true).isValid()
          ? dayjs(rangeEnd, "MM/DD/YYYY").format("MM/DD/YYYY")
          : "";
  
        sendDataToParent(formatted, endValid, period);
        setCalendarValue(dayjs());// Reset calendar to current date when period changes
      } else {
        const startValid = dayjs(rangeStart, "MM/DD/YYYY", true).isValid()
          ? dayjs(rangeStart, "MM/DD/YYYY").format("MM/DD/YYYY")
          : "";
          
          sendDataToParent(startValid, formatted, period);
          setCalendarValue(dayjs());// Reset calendar to current date when period changes
        }
      } else {
      setDateError("Please enter a valid date in MM/DD/YYYY format.");
    }
  };
  
  
  const wrapperStyle = {
    width: 300,
    border: "0px",
    borderRadius: "0px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  };
  
  dayjs.extend(isBetween);
  
  console.log('dynamicLastmonths' , dynamicLastmonths)
  
  return (
    <div style={wrapperStyle}>
      <Calendar
        fullscreen={false}
        value={calendarValue}
        onChange={(newValue) => setCalendarValue(newValue)}
        fullCellRender={(date) => {
          const start = rangeStart ? dayjs(rangeStart) : null;
          const end = rangeEnd ? dayjs(rangeEnd) : null;

          const isInRange =
            start && end && date.isBetween(start, end, "day", "[]");

          return (
            <div
              className={`xyz ${isInRange ? "highlight-range" : ""} 
                                       ${
                                         date.isSame(rangeStart, "day")
                                           ? "range-cell-customization"
                                           : ""
                                       } 
                                        ${
                                          date.isSame(rangeEnd, "day")
                                            ? "range-cell-customization"
                                            : ""
                                        }`}
            >
              {date.date()}
            </div>
          );
        }}
        headerRender={({ value, onChange }) => {
          const start = 0;
          const end = 12;
          const monthOptions = [];

          let current = value.clone();
          const localeData = value.localeData();
          const months = [];
          for (let i = 0; i < 12; i++) {
            current = current.month(i);
            months.push(localeData.monthsShort(current));
          }

          for (let i = start; i < end; i++) {
            monthOptions.push(
              <Select.Option key={i} value={i} className="month-item">
                {months[i]}
              </Select.Option>
            );
          }

          const handlePrev = () => {
            buttonPress.current = true;
            const newValue = value.clone().subtract(1, "month");
            onChange(newValue); // Update the calendar to the new value
          };

          const handleNext = () => {
            buttonPress.current = true;
            const newValue = value.clone().add(1, "month"); // Add one month to the current value
            onChange(newValue); // Update the calendar to the new value
          };

          const year = value.year();
          const month = value.month();
          const options = [];
          for (let i = year - 10; i < year + 10; i += 1) {
            options.push(
              <Select.Option key={i} value={i} className="year-item">
                {i}
              </Select.Option>
            );
          }
          return (
            <Row
              gutter={8}
              style={{
                paddingBottom: "16px",
                paddingTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Col
                span={11}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* <Button
                                    icon={<img width="12px" src={LeftIcon}></img>}
                                    onClick={handlePrev}
                                    style={{border:"0px",background:"none", boxShadow:"none",padding:"0px",margin:"0px"}}
                                /> */}

                <button
                  style={{ display: "contents", cursor: "pointer" }}
                  type="button"
                  onClick={handlePrev}
                >
                  <img width="12px" src={LeftIcon} />
                </button>
                <Select
                  style={{ width: "55%" }}
                  popupMatchSelectWidth={false}
                  value={month}
                  onChange={(newMonth) => {
                    buttonPress.current = true;
                    const now = value.clone().month(newMonth);
                    onChange(now);
                  }}
                  suffixIcon={<img src={ArrowDown} />}
                  className="date-select-month"
                >
                  {monthOptions}
                </Select>
              </Col>
              <Col
                span={11}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Select
                  style={{ width: "60%" }}
                  popupMatchSelectWidth={false}
                  className="my-year-select date-select-month"
                  value={year}
                  onChange={(newYear) => {
                    buttonPress.current = true;
                    const now = value.clone().year(newYear);
                    onChange(now);
                  }}
                  suffixIcon={<img src={ArrowDown} />}
                >
                  {options}
                </Select>
                {/* <Button
                  style={{ display: "contents" }}
                  type="button"
                  icon={<img width="26px" src={RightIcon} />}
                  onClick={handleNext}
                /> */}
                <button
                  style={{ display: "contents", cursor: "pointer" }}
                  type="button"
                  onClick={handleNext}
                >
                  <img width="26px" src={RightIcon} />
                </button>
              </Col>
            </Row>
          );
        }}
        onSelect={onDateChange}
      />
      <Row>
        <Col span={24}>
          <CustomTitle
            text={"Reporting period"}
            color="#000"
            fontSize="12px"
            lineHeight="20px"
            fontWeight="600"
            marginBottom={0}
          />
          <CustomSelect
            placeholder="Choose period"
            value={period}
            onChange={handlePeriodChange}
            allowClear={false}
            lineHeight={"16px"}
            fontWeight="600"
            border="0px"
            bgColor={"#F3F3F3"}
            borderRadius={"4px"}
            boxShadow={"none"}
            height="28px"
            // options={ReportingPeriodList}
            options={dynamicLastmonths}
            suffixIcon={<img src={ArrowDown} />}
          />
        </Col>
      </Row>

      <Row
        style={{
          margin: "0px",
          display: "Flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Col span={11}>
          <CustomTitle
            text={"Start"}
            color="#000"
            fontSize="12px"
            lineHeight="20px"
            fontWeight="600"
            marginBottom={0}
          />
          <CustomInput
            placeholder="mm/dd/yyyy"
            height="28px"
            width="100%"
            type="text"
            border="0px"
            bgColor="#F3F3F3"
            textColor="#000"
            fontSize="12px"
            borderRadius="4px"
            placeholderColor="#5E5E5E"
            lineHeight="38px"
            value={rangeStart} // Should be "MM/DD/YYYY"
            onChange={(e) => handleDateSelect(e, "start")}
            disabled={period !== "Custom"}
          />
        </Col>
        <Col span={11}>
          <CustomTitle
            text={"End"}
            color="#000"
            fontSize="12px"
            lineHeight="20px"
            fontWeight="600"
            marginBottom={0}
          />
          <CustomInput
            placeholder="mm/dd/yyyy"
            height="28px"
            width="100%"
            type="text"
            border="0px"
            bgColor="#F3F3F3"
            textColor="#000"
            fontSize="12px"
            borderRadius="4px"
            placeholderColor="#5E5E5E"
            lineHeight="38px"
            value={rangeEnd} // Should be "MM/DD/YYYY"
            onChange={(e) => handleDateSelect(e, "end")}
            disabled={period !== "Custom"}
          />
        </Col>
        {error || dateError ? (
          <Col span={24}>
            <CustomParagraph
              text={
                dateError
                  ? dateError
                  : "Start range must be less than end range."
              }
              color="#ff4d4f"
              fontSize="12px"
              fontWeight="400"
              lineHeight="28px"
              marginBottom={0}
            />
          </Col>
        ) : null}

        {/* <Col style={{marginTop:"12px",display:"flex",justifyContent:"end",width:"100%"}}>
                <CustomButton text="Apply" onClick={sendDataToParent} width={62} height={36} bgColor="#000" color="#fff" fontSize={12} fontWeight={500} borderRadius={8} boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.27)" />
                </Col> */}
      </Row>
    </div>
  );
};

export default HomeDateFilter;
